import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Text from '../../../Text'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'

function GetFasterAudience({
  eyebrow,
  title,
  cards = []
}) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          {eyebrow && <Text type="heading-8" color={$textTertiary.dark}>{eyebrow}</Text>}
          {title && (
            <h2 className={styles.title}>
              <SimpleBlockContent blocks={title} />
            </h2>
          )}
        </div>

        <div className={styles.cardsGrid}>
          {cards.map((card, index) => {
            // task #67: card.image is now a ResolvedImage descriptor; use .src
            const imageSrc = card.image?.src || null

            return (
              <div className={styles.card} key={index}>
                <div className={styles.cardImageArea}>
                  {/* eslint-disable-next-line local-rules/prefer-img-component -- Phase 3.5 (#89) faithful CSS-Modules port of the former styled.img; box reserved via aspect-ratio (styles.cardImage / inline aspectRatio), no CLS. */}
                  {imageSrc && <img className={styles.cardImage} src={imageSrc} style={{ aspectRatio: card.image?.aspectRatio }} alt="" />}
                </div>
                <div className={styles.cardContent}>
                  <h3 className={styles.cardTitle}><Text type="heading-5" color={$textPrimary.dark}>{card.title}</Text></h3>
                  <div className={styles.cardDescription}><Text type="regular" color={$textTertiary.dark}>{card.description}</Text></div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default GetFasterAudience
